const APP_CALCULATION_TOGGLE = process.env.REACT_APP_APPARATUS_FEATURE_TOGGLE_CALCULATION_MANAGER
const APP_GROUP_TOGGLE = process.env.REACT_APP_APPARATUS_FEATURE_TOGGLE_GROUP_MANAGER
const APP_ADMIN_ACTIONS_TOGGLE = process.env.REACT_APP_APPARATUS_FEATURE_TOGGLE_ADMIN_ACTIONS

export const FEATURE_OPTIONS = {
  ADMIN_ACTIONS: 'admin-actions',
  CALCULATION: 'calculation',
  GROUP: 'group',
} as const

export type FeatureOptionsType = typeof FEATURE_OPTIONS[keyof typeof FEATURE_OPTIONS]

export const verifyFeature = (feature: FeatureOptionsType) => {
  switch (feature) {
    case FEATURE_OPTIONS.ADMIN_ACTIONS:
      return APP_ADMIN_ACTIONS_TOGGLE === 'enabled'
    case FEATURE_OPTIONS.GROUP:
      return APP_GROUP_TOGGLE === 'enabled'
    case FEATURE_OPTIONS.CALCULATION:
      return APP_CALCULATION_TOGGLE === 'enabled'
  }
}
